/* eslint-disable import/prefer-default-export */
import axios from 'axios';
import { getLoginUser } from './loginService';
import { isCallcenterLoggedIn, getCallcenterUser } from './callcenterService';

const baseUrl = `${process.env.BACKEND_API_BASE_URL}/route-plan.php`;

const getToken = () => (isCallcenterLoggedIn() ? getCallcenterUser() : getLoginUser()).token;

export const routePlanService = {
  route_plan_calculation: async (jobs, vehicles) => {
    // Use URLSearchParams to send as form data to avoid CORS preflight
    const formData = new URLSearchParams();
    formData.append('method', 'route_plan_calculation');
    formData.append('token', getToken());
    formData.append('jobs', JSON.stringify(jobs));
    formData.append('vehicles', JSON.stringify(vehicles));

    return axios.post(baseUrl, formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
  },
};
